import React from 'react';
import { SyncLoader } from 'react-spinners'

const Loader = () => {
    return (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'center', minHeight: '200px', alignItems: "center" }} ><SyncLoader color="#00504E" /></div>
    )
}

export default Loader